/**
 * UNIT-CHIP
 * Chip for a work unit : whole establishment, site or population
 * Single source of truth for the icon / label of a unit
 */
import FilterChip from "@/components/FilterChip"
import { Population } from "@/entities/population/model/population.types"
import { Site } from "@/entities/site/model/site.types"
import { faBuilding, faLocationDot, faRoute, faUserFriends } from "@fortawesome/free-solid-svg-icons"

type UnitChipValue =
  | { type: "establishment"; name: string }
  | { type: "site"; site: Site }
  | { type: "population"; population: Population }

interface Props {
  activeMultiple?: boolean //Always display the secondary action (+ / -)
  hideIcon?: boolean //Hide the unit icon
  isActive?: boolean //Selected (neutral chip highlight)
  onAddClick?: () => void
  onClick?: () => void
  onRemoveClick?: () => void
  unit: UnitChipValue
}

function getUnitName(unit: UnitChipValue) {
  if (unit.type === "establishment") return "Tout l'établissement " + unit.name
  if (unit.type === "site") return unit.site.name
  return unit.population.name
}

function getUnitIcon(unit: UnitChipValue) {
  if (unit.type === "establishment") return faBuilding
  if (unit.type === "site") return unit.site.geometryType === "line" ? faRoute : faLocationDot
  return faUserFriends
}

export default function UnitChip({
  activeMultiple,
  hideIcon,
  isActive,
  onAddClick,
  onClick,
  onRemoveClick,
  unit
}: Props) {
  return (
    <FilterChip
      activeMultiple={activeMultiple}
      hideIcon={hideIcon}
      icon={getUnitIcon(unit)}
      isActive={isActive}
      name={getUnitName(unit)}
      onAddClick={onAddClick}
      onClick={onClick}
      onRemoveClick={onRemoveClick}
    />
  )
}
